<template>
  <div>
    <navbar-component></navbar-component>
    <main>
      <page-header title="Information Technology"
                   :links="[{title:'Home', url:'/'},{title:'PEO,PSO,PO'}]"></page-header>
      <div class="container-2">
        <section class="sidebar">
          <sidebar :active="3"></sidebar>
        </section>
        <section class="content">
          <div class="heading-black1">PEO,PSO,PO</div>
          <Accordion :activeIndex="0">
            <AccordionTab header="Program Educational Objectives (PEOs)">
              <ul class="list-inside">
                <li class="flex justify-start pb-2" v-for="(peo,index) in PEOS" :key="index">
                  <span class="font-semibold mr-2">{{ peo.title }}:</span>
                  <p>{{ peo.description }}</p>
                </li>
              </ul>
            </AccordionTab>
            <AccordionTab header="Program Specific Outcomes (PSOs)">
              <ul class="list-inside">
                <li class="flex justify-start pb-2" v-for="(pso,index) in PSOS" :key="index">
                  <span class="font-semibold mr-2">{{ pso.title }}:</span>
                  <p>{{ pso.description }}</p>
                </li>
              </ul>
            </AccordionTab>
            <AccordionTab header="Program Outcomes (POs)">
              <ul class="list-inside">
                <li class="flex flex-col justify-start pb-2" v-for="(po,index) in POS" :key="index">
                  <span class="font-semibold mr-2">{{ po.title }}:</span>
                  <p class="ml-10">{{ po.description }}</p>
                </li>
              </ul>
            </AccordionTab>
          </Accordion>
        </section>
      </div>
      <key-recruiters></key-recruiters>
    </main>
    <footer-component></footer-component>
  </div>
</template>
<script>
import NavbarComponent from "@/components/Navbar.vue";
import FooterComponent from "@/components/Footer.vue";
import PageHeader from "@/components/PageHeader";
import Sidebar from "@/views/academics/it/Sidebar";
import Accordion from 'primevue/accordion';
import AccordionTab from 'primevue/accordiontab';
import KeyRecruiters from "@/components/KeyRecruiters";

export default {
  name: "PosPeos",
  components: {
    NavbarComponent,
    PageHeader,
    Sidebar,
    FooterComponent,
    KeyRecruiters,
    Accordion,
    AccordionTab
  },
  setup() {
    const carouselSlides = ["bg-1", "bg-2", "bg-3"];
    return {carouselSlides};
  },
  data() {
    return {
      div: null,
      PEOS: [
        {
          title: 'PEO1',
          description: 'Possess strong fundamental concepts in mathematics, science, engineering and technology to address technological challenges.'
        },
        {
          title: 'PEO2',
          description: 'Possess knowledge and skills in the field of Computer Science & Engineering and Information Technology for analyzing, designing and implementing complex engineering problems of any domain with innovative approaches.'
        },
        {
          title: 'PEO3',
          description: 'Possess an attitude and aptitude for research, entrepreneurship and higher studies in the field of Information Technology.'
        },
        {
          title: 'PEO4',
          description: 'Have commitment to ethical practices, societal contributions through communities and life -long learning.'
        },
        {
          title: 'PEO5',
          description: 'Possess better communication, presentation, time management and team work skills leading to responsible & competent professionals and will be able to address challenges in the field of IT at global level.'
        },],
      PSOS: [
        {
          title: 'PSO1',
          description: 'An ability to apply the theoretical concepts and practical knowledge of Information Technology in analysis, design, development and management of information processing systems and applications in the interdisciplinary domain.'
        },
        {
          title: 'PSO2',
          description: ' An ability to analyze a problem, and identify and define the computing infrastructure and operations requirements appropriate to its solution. IT graduates should be able to work on large-scale computing systems.'
        },
        {
          title: 'PSO3',
          description: 'An understanding of professional, business and business processes, ethical, legal, security and social issues and responsibilities.'
        },
        {
          title: 'PSO4',
          description: 'Practice communication and decision-making skills through the use of appropriate technology and be ready for professional responsibilities.'
        },
      ],
      POS: [
        {
          title: 'PO1',
          description: 'An ability to apply knowledge of computing, mathematics including discrete mathematics as well as probability and statistics, science, and engineering and technology.'
        },
        {
          title: 'PO2',
          description: 'An ability to define a problem and provide a systematic solution with the help of conducting experiments, as well as analyzing and interpreting the data. '
        },
        {
          title: 'PO3',
          description: 'An ability to design, implement, and evaluate a software or a software/hardware system, component, or process to meet desired needs within realistic constraints.'
        },
        {
          title: 'PO4',
          description: 'An ability to identify, formulate, and provide systematic solutions to complex engineering problems.'
        },
        {
          title: 'PO5',
          description: 'An ability to use the techniques, skills, and modern engineering technologies tools, standard processes necessary for practice as a IT professional. '
        },
        {
          title: 'PO6',
          description: 'An ability to apply mathematical foundations, algorithmic principles, and computer science theory in the modeling and design of computer-based systems with necessary constraints and assumptions.'
        },
        {
          title: 'PO7',
          description: 'An ability to analyze the local and global impact of computing on individuals, organizations and society.'
        },
        {
          title: 'PO8',
          description: 'An ability to understand professional, ethical, legal, security and social issues and responsibilities.'
        },
        {
          title: 'PO9',
          description: 'An ability to function effectively as an individual or as a team member to accomplish a desired goal(s).'
        },
        {
          title: 'PO10',
          description: 'An ability to engage in life-long learning and continuing professional development to cope up with fast changes in the technologies/tools with the help of electives, professional organizations and extra-curricular activities.'
        },
        {
          title: 'PO11',
          description: 'An ability to communicate effectively in engineering community at large by means of effective presentations, report writing, paper publications, demonstrations.'
        },
        {
          title: 'PO12',
          description: 'An ability to understand engineering, management, financial aspects, performance, optimizations and time complexity necessary for professional practice.'
        },
        {
          title: 'PO13',
          description: 'An ability to apply design and development principles in the construction of software systems of varying complexity.'
        },
      ]
    }
  }
}
</script>
<style lang="scss" scoped/>
